import { lazy, Suspense, useContext } from "react";
import { BrowserRouter, Routes, Route, Navigate, Link } from "react-router-dom";
import { Spin } from "antd";
import { UserContext } from "../../context/User.context";

const Login = lazy(() =>
  import("../../layout/auth/login/login").then((m) => ({ default: m.Login }))
);
const Main = lazy(() =>
  import("../../layout/Main").then((m) => ({ default: m.Main }))
);
const Home = lazy(() =>
  import("../../layout/landingpage/Index").then((m) => ({ default: m.Home }))
);
const TicketProgress = lazy(() =>
  import("../../layout/view/guest/TicketProgress").then((m) => ({
    default: m.TicketProgress,
  }))
);
const DashboardUser = lazy(() =>
  import("../../layout/view/admin/dashboard/DashboardUser").then((m) => ({
    default: m.DashboardUser,
  }))
);
const ProfileUser = lazy(() =>
  import("../../layout/view/admin/profile/ProfileUser").then((m) => ({
    default: m.ProfileUser,
  }))
);
const ProfileEdit = lazy(() =>
  import("../../layout/view/admin/profile/ProfileEdit").then((m) => ({
    default: m.ProfileEdit,
  }))
);
const ChangePassword = lazy(() =>
  import("../../layout/view/admin/profile/ChangePwd").then((m) => ({
    default: m.ChangePassword,
  }))
);
const ListTicket = lazy(() =>
  import("../../layout/view/admin/jobticket/JobTicket").then((m) => ({
    default: m.ListTicket,
  }))
);
const AssetITList = lazy(() =>
  import("../../layout/view/admin/assetit/AssetITList").then((m) => ({
    default: m.AssetITList,
  }))
);
const AssetHSEList = lazy(() =>
  import("../../layout/view/admin/assethse/AssetHSEList").then((m) => ({
    default: m.AssetHSEList,
  }))
);
const DashboardOverview = lazy(() =>
  import("../../layout/view/admin/dashboard/DashboardOverview").then((m) => ({
    default: m.DashboardOverview,
  }))
);
const MasterData = lazy(() =>
  import("../../layout/view/admin/masterdata/MasterData").then((m) => ({
    default: m.MasterData,
  }))
);
const RoleAccess = lazy(() =>
  import("../../layout/view/admin/roleaccess/RoleAccess").then((m) => ({
    default: m.RoleAccess,
  }))
);

const RouteFallback = () => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "60vh",
    }}
  >
    <Spin size="large" />
  </div>
);

const RequireAuth = ({ children }) => {
  const { user } = useContext(UserContext);
  return user ? children : <Navigate to="/login" replace />;
};

const RedirectIfAuthed = ({ children }) => {
  const { user } = useContext(UserContext);
  return user ? <Navigate to="/user" replace /> : children;
};

const MainRouter = () => (
  <BrowserRouter>
    <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route
          path="/login"
          element={
            <RedirectIfAuthed>
              <Login />
            </RedirectIfAuthed>
          }
        />

        <Route path="/" element={<Main />}>
          <Route index element={<Home />} />
          <Route path="ticket-progress" element={<TicketProgress />} />
        </Route>

        <Route
          path="/user"
          element={
            <RequireAuth>
              <DashboardUser />
            </RequireAuth>
          }
        >
          <Route index element={<Navigate to="/user/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardOverview />} />
          <Route path="ticket-list" element={<ListTicket />} />
          <Route path="asset-it" element={<AssetITList />} />
          <Route path="asset-hse" element={<AssetHSEList />} />
          <Route path="master-data" element={<MasterData />} />
          <Route path="role-access" element={<RoleAccess />} />
          <Route path="profile" element={<ProfileUser />} />
          <Route path="profile-edit" element={<ProfileEdit />} />
          <Route path="change-pwd" element={<ChangePassword />} />
        </Route>

        <Route path="*" element={<NoMatchPage />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
);

function NoMatchPage() {
  return (
    <div>
      <h2>Nothing to see here!</h2>
      <p>
        <Link to="/">Back to login</Link>
      </p>
    </div>
  );
}

export default MainRouter;
